module.exports = __webpack_public_path__ + "static/media/wizualizacja-152.24e4c685.png";